import { getApiUrl } from "./tcApiUrl";
export function uploadAndValidateURL() {
  const uploadandvalidateurlvalue = `${getApiUrl("tc/validate")}`;
  return uploadandvalidateurlvalue;
}
export const uploadAndValidateURLValue = () => {
  return uploadAndValidateURL();
};
